import { render, staticRenderFns } from "./DialogTaoPhieuDieuChinh.vue?vue&type=template&id=2c88c284"
import script from "./DialogTaoPhieuDieuChinh.vue?vue&type=script&lang=js"
export * from "./DialogTaoPhieuDieuChinh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports